<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <p class="f16">指定商品弹窗</p>
    <div class="mt20">
      弹窗文案：
      <el-input type="textarea" placeholder="文案" :rows="4" v-model.trim="form.popContent" style="width: 200px"></el-input>
    </div>

    <p class="mt20 mb10">SPU导入</p>
    <div class="upload-container">
      <div class="upload-btn">
        <el-button type="primary" icon="el-icon-upload" plain>点击上传</el-button>
        <input @change="(e) => changeFile(e, 2)" accept=".xls,.xlsx" type="file" />
      </div>
      <!-- <el-button type="text" @click="downloadTemplate">下载文件模板</el-button> -->
    </div>
    <p class="mt10 gray">只能上传.xls .xlsx</p>
    <template v-if="form.fileName">
      <div class="file-item bg-gray"><i class="el-icon-document"></i> {{ form.fileName }}</div>
      <el-button class="ml20" type="text" size="mini" @click="downloadFile(form.fileUrl)">下载</el-button>
    </template>

    <div class="mt20">
      <el-button type="primary" @click="submitUpload">保存生效</el-button>
    </div>
  </div>
</template>

<script>
import Client from "@/utils/client.js";
import { downloadUrlFile } from '@/utils/functions';
import { fileUpload } from '../../api/merchants';
import {
  saveSellerAlertSPU,
  getSellerAlertSPU,
} from './api';

export default {
  data() {
    return {
      fullscreenLoading: false,
      form: {
        fileUrl: null,
        fileName: null,
        popContent: null,
      },
    };
  },
  mounted() {
    this.getSellerAlertSPU();
  },
  methods: {
    getSellerAlertSPU() {
      getSellerAlertSPU().then(res => {
        if (res.data && res.data.success) {
          this.form = res.data.data;
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      })
    },
    async changeFile(e, type) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (type === 1 && !/\.(png|jpe?g)(\?.*)?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.jpg .jpeg .png格式');
          return;
        }
        if (type === 2 && !/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.xls .xlsx格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        if (type === 1) {
          // nothing
        } else {
          this.form.fileUrl = res.url;
          this.form.fileName = file.name.substring(file.name.lastIndexOf('/'));
        }
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    submitUpload() {
      if (!this.form.popContent) {
        this.$message('请输入弹窗文案');
        return;
      }
      if (!this.form.fileUrl) {
        this.$message('请上传SPU导入文件');
        return;
      }
      this.$confirm(`确认信息无误？`, '确认', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        saveSellerAlertSPU(this.form).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success('保存成功');
            this.getSellerAlertSPU();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => {});
    },
    downloadTemplate() {
    },
    downloadFile(url) {
      downloadUrlFile(url);
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
  font-size: 14px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.gray {
  color: #939da9;
}
.bg-gray {
  background-color: #f2f2f2;
}
.f16 {
  font-size: 16px;
}
.upload-container {
  display: flex;

  .upload-btn {
    position: relative;
    margin-right: 50px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
}
.tag-img {
  display: block;
  max-width: 200px;
}
</style>
